import * as _4 from 'lodash4';

export class LoginFormController {
  private models: {
    credentials: {
      username: string;
      password: string;
    };
    loginLabel: string;
  };
  private customLoginFieldPlaceholder: string;
  private errorReason?: string;
  private loginHelpButtonLabel: string = 'Need help logging in?';

  constructor(
    private $state: any,
    private loginCommand: any,
    private $injector: any,
    private authenticationConfiguration: any,
    private ngAuthenticationQueryModel: any,
    private accountModel: any,
    private appConfigModel: any
  ) {
    this.models = {
      credentials: {
        username: '',
        password: ''
      },
      loginLabel: this.ngAuthenticationQueryModel.read().member.user_id_label
    };

    this.customLoginFieldPlaceholder = _4.isEmpty(_4.trim(this.models.loginLabel))
      ? 'Enter your User ID'
      : this.models.loginLabel;
    this.loginHelpButtonLabel = _4.get(
      appConfigModel,
      'model.member_configs.auth-login_help_button_label',
      this.loginHelpButtonLabel
    );
  }

  requestAuthentication(): void {
    this.loginCommand(this.models.credentials)
      .then(() => {
        if (this.authenticationConfiguration.read().onLoggedInFormSuccess) {
          this.$injector.get(this.authenticationConfiguration.read().onLoggedInFormSuccess)(
            this.$state,
            this.accountModel
          );
        }
      })
      .catch((loginFailure: any) => {
        const explicitErrorReason = loginFailure.reason || this.$state.current.data.defaultErrorMessage;
        this.$state.go(`authentication.form.failure`, { explicitErrorReason });
      });
  }

  formHasData(): boolean {
    const authenticationCredentials: {
      username: string;
      password: string;
    } = this.models.credentials;

    return (
      _4.isString(authenticationCredentials.username) &&
      _4.isString(authenticationCredentials.password) &&
      authenticationCredentials.username.length > 0 &&
      authenticationCredentials.password.length > 0
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-authentication/src/views/type_form/type_form.ts